<div class="w-full">
  <div class="p-2 text-lg text-center">
    Visões
    <i
      class="pi pi-info-circle text-primary cursor-pointer ml-1 text-sm"
      (click)="op.toggle($event)"
      [attr.data-tooltip]="tooltipKey"
    ></i>
  </div>
  <p-popover #op>
    <ng-template pTemplate="content">
      <div class="tooltip-overlay" [innerHTML]="tooltipHtml | safeHtml">
        Você pode editar o nome da visão e as configurações de colunas da tabela antes de salvar.
      </div>
      @if (tooltipUrl && (suporteVisible$ | async)) {
        <div class="mt-4">
          <a class="text-primary" [href]="tooltipUrl" target="_blank" rel="noopener">
            Documentação
            <i class="pi pi-external-link text-sm ml-1"></i>
          </a>
        </div>
      }
      <div class="mt-2 text-sm">
        <a pTooltip="Editar este conteúdo" tooltipPosition="bottom" class="link" href="{{ orientacoesEditUrl }}" target="_blank" rel="noopener">
          Editar
        </a>
      </div>
    </ng-template>
  </p-popover>
  <div>
    <form>
      <div class="flex p-2 border-top-1 border-black-alpha-20">
        <input
          pInputText
          placeholder="Nome da visão"
          class="w-10 view-name-input"
          [(ngModel)]="inputName"
          [ngModelOptions]="{ standalone: true }"
          />

          <div class="actions flex w-2">
            @if (!viewEditing) {
              <button
                type="button"
                pButton
                text
                size="small"
                icon="pi pi-plus"
                pTooltip="Adicionar"
                tooltipPosition="bottom"
                [disabled]="!inputName?.trim()"
                (click)="createView()"
              ></button>
              <button
                type="button"
                pButton
                text
                size="small"
                severity="secondary"
                icon="pi pi-undo"
                pTooltip="Resetar"
                tooltipPosition="bottom"
                (click)="resetView()"
              ></button>
            }
            @if (viewEditing) {
              <button
                type="button"
                pButton
                text
                size="small"
                icon="pi pi-save"
                pTooltip="Atualizar"
                tooltipPosition="bottom"
                [disabled]="!inputName?.trim()"
                (click)="updateView()"
              ></button>
              <button
                type="button"
                pButton
                text
                size="small"
                severity="secondary"
                icon="pi pi-times"
                pTooltip="Cancelar"
                tooltipPosition="bottom"
                (click)="cancelEditView()"
              ></button>
            }
          </div>
        </div>
      </form>
      <div class="p-2 border-top-1 border-black-alpha-20">
        @if (!viewsList.length) {
          <div class="text-center">- sem visões -</div>
        }
        <div class="drag-list">
          @for (view of viewsList; track view; let i = $index) {
            <div
              pDraggable="views"
              pDroppable="views"
              dragHandle=".drag-handle"
              (onDragStart)="onDragStart(i)"
              (onDragEnter)="onDragEnter(i)"
              (onDrop)="onDrop(i)"
              class="drag-wrapper"
          [ngClass]="{
            'drag-source': i == dragStartIndex,
            'drag-target-up': i == dragEnterIndex && dragEnterIndex < dragStartIndex,
            'drag-target-down': i == dragEnterIndex && dragEnterIndex > dragStartIndex
          }"
              >
              <div class="drag-drop-area drag-drop-area-up"></div>
              <div class="drag-item flex flex-column w-full gap-2" [ngClass]="{ editing: view == viewEditing }">
                <div class="flex align-items-center gap-2">
                  <i class="drag-handle ag-icon ag-icon-grip"></i>
                  <div class="bold">
                    {{ view.nm_visao }}
                  </div>
                </div>
                <div class="actions flex justify-content-between align-items-center">
                  <p-checkbox
                    size="small"
                    class="ml-2"
                    pTooltip="Fixado"
                    tooltipPosition="bottom"
                    [ngModel]="!!view.ib_fixado" (ngModelChange)="view.ib_fixado = $event"
                    [binary]="true"
                    (onChange)="onPinnedToggle(view)"
                  ></p-checkbox>
                  <div class="flex align-items-center gap-2">
                    <button
                      type="button"
                      pButton
                      text
                      size="small"
                      icon="pi pi-pencil"
                      pTooltip="Editar"
                      tooltipPosition="bottom"
                      (click)="editView(view)"
                    ></button>
                    <button
                      type="button"
                      pButton
                      text
                      size="small"
                      severity="danger"
                      icon="pi pi-trash"
                      pTooltip="Remover"
                      tooltipPosition="bottom"
                      (click)="removeView(view)"
                    ></button>
                  </div>
                </div>
              </div>
              <div class="drag-drop-area drag-drop-area-down"></div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

